import { Box } from '@mui/material';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { BOUND_COLORS } from '../functions';

const mockdata = [
  { name: 'Vendedor A', value: 400 },
  { name: 'Vendedor B', value: 300 },
  { name: 'Vendedor C', value: 300 },
  { name: 'Vendedor D', value: 200 },
];

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }, source, vx, vy, renderValue = null) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 1.25;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="black" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
      {source[index][vx || 'name']}: {renderValue ? renderValue(vy, source[index]) : source[index][vy || 'count']}
    </text>
  );
};

const getEntryColor = (entry, vx) =>
  BOUND_COLORS[String(entry?.[vx || 'name'])] || BOUND_COLORS[String(entry?.owner_name)]

const JourneyPieChart = ({ data, vx, vy, renderValue }) => {

  return (
    <Box sx={{ width: '100%', height: '100%' }}
    >
      <ResponsiveContainer width="100%" height="100%" >
        <PieChart width={400} height={400} >
          <Pie
            data={data || mockdata}
            nameKey={vx || 'name'}
            dataKey={vy || "value"}
            fill="#8884d8"
            label={(args) => renderCustomizedLabel(args, data || mockdata, vx, vy, renderValue)}>
            {data.map((entry, index) =>
            (
              <Cell key={`cell-${index}`} fill={getEntryColor(entry, vx)} />
            ))}
          </Pie>
          <Tooltip formatter={(value, name, { payload }) => renderValue ? renderValue(vy, payload) : ''} />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
}


export default JourneyPieChart
